import "antd/es/input/style";
import _Input from "antd/es/input";
var _excluded = ["className", "currency", "currencyProps", "amountProps", "value", "seperator", "separator", "decimalSeparator", "disabled"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { jsx as _jsx } from "react/jsx-runtime";
import omit from 'omit.js';
import formMethods from '../utils/form-methods';
import classnames from 'classnames';
import { staticFormatMessage } from '../locale';
import './style/index.less';

var thousands = function thousands(number, decimalSeparator, separator) {
  if (number === null || number === undefined) return undefined;
  var arr = String(number).replace('.', decimalSeparator).split(decimalSeparator);
  return arr.map(function (s, index) {
    if (index === 0) {
      return s.replace(/(?=(?!\b)(\d{3})+$)/g, separator);
    }

    return s.replace(/(\d{3})(?=[^$])/g, "$1".concat(separator));
  }).join(decimalSeparator);
};

var Amount = function Amount(_ref) {
  var className = _ref.className,
      currency = _ref.currency,
      _ref$currencyProps = _ref.currencyProps,
      currencyProps = _ref$currencyProps === void 0 ? {} : _ref$currencyProps,
      _ref$amountProps = _ref.amountProps,
      amountProps = _ref$amountProps === void 0 ? {} : _ref$amountProps,
      value = _ref.value,
      seperator = _ref.seperator,
      _ref$separator = _ref.separator,
      separator = _ref$separator === void 0 ? seperator || ',' : _ref$separator,
      _ref$decimalSeparator = _ref.decimalSeparator,
      decimalSeparator = _ref$decimalSeparator === void 0 ? '.' : _ref$decimalSeparator,
      disabled = _ref.disabled,
      rest = _objectWithoutProperties(_ref, _excluded);

  var handleOnBlur = function handleOnBlur(e) {
    var onChange = rest.onChange;

    if (typeof value === 'string') {
      if (value.endsWith(decimalSeparator)) {
        e.target.value = value.replace(decimalSeparator, '');
      }

      if (value.endsWith('0') && value.includes(decimalSeparator)) {
        e.target.value = value.replace(/[0]+$/, '');
      }

      onChange && onChange(e);
    }
  };

  return _jsx(_Input, _objectSpread(_objectSpread({
    onBlur: handleOnBlur
  }, omit(rest, formMethods)), {}, {
    disabled: disabled,
    className: classnames('igloo-input-amount', {
      'igloo-input-disable': disabled
    }, className),
    value: thousands(value, decimalSeparator, separator),
    addonBefore: currency ? _jsx("span", {
      className: "igloo-input-areacode",
      children: currency
    }) : null
  }));
};

Amount.formItemPropsHandler = function (_ref2) {
  var _ref2$separator = _ref2.separator,
      separator = _ref2$separator === void 0 ? ',' : _ref2$separator,
      _ref2$decimalSeparato = _ref2.decimalSeparator,
      decimalSeparator = _ref2$decimalSeparato === void 0 ? '.' : _ref2$decimalSeparato;
  return {
    getValueFromEvent: function getValueFromEvent(e) {
      var value = e.target.value;
      var str = value.replaceAll(separator, '').replaceAll(/[^0-9\.,]/g, '');

      if (str.endsWith(decimalSeparator) || str.includes(decimalSeparator) && str.endsWith('0')) {
        return str;
      }

      if (decimalSeparator === ',') {
        str = str.replace(',', '.');
      }

      return str ? parseFloat(str) : undefined;
    },
    rules: [{
      validator: function validator(_, value) {
        if (!value) return Promise.resolve();
        var separatorArr = String(value).split(decimalSeparator);
        return separatorArr.length > 2 ? Promise.reject(staticFormatMessage({
          id: 'Please enter a valid amount.'
        })) : Promise.resolve();
      }
    }]
  };
};

export default Amount;